<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="年度">
          <el-select v-model="formInline.year" placeholder="请选择年度" class="w120">
            <el-option label="2026" value="2026"></el-option>
            <el-option label="2025" value="2025"></el-option>
            <el-option label="2024" value="2024"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属组织">
          <el-select v-model="formInline.organization" placeholder="请选择所属组织" clearable filterable class="w200">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in organizationList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="牌照号码">
          <el-input placeholder="请输入牌照号码" v-model="formInline.license_number" class="w200"></el-input>
        </el-form-item>
        <el-form-item label="车辆类型">
          <el-select v-model="formInline.vehicle_type" placeholder="所有" clearable filterable class="w120">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in vehicleTypeList" :key="item.vehicle_classification_id" :label="item.name" :value="item.vehicle_classification_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="所有" class="w120">
            <el-option label="所有" value=""></el-option>
            <el-option label="正常" value="1"></el-option>
            <el-option label="不正常" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入时间">
          <el-date-picker v-model="formInline.start_date" type="date" placeholder="开始日期" class="w150"></el-date-picker>
          <span class="ml10 mr10">至</span>
          <el-date-picker v-model="formInline.end_date" type="date" placeholder="结束日期" class="w150"></el-date-picker>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="getData">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加车辆</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>

            <!-- <el-table-column prop="name" label="车辆档案名称"></el-table-column> -->

            <el-table-column prop="equipmentCategory.name" label="设备分类"></el-table-column>
<el-table-column prop="licenseCategory.name" label="牌照分类"></el-table-column>
<el-table-column prop="vehicleCategory.name" label="车辆分类"></el-table-column>
<el-table-column prop="license_number" label="牌照号码"></el-table-column>
<el-table-column prop="belongOrganization.name" label="所属组织"></el-table-column>
<el-table-column prop="administrative_region" label="行政区域"></el-table-column>
<el-table-column prop="status" label="状态">
  <template slot-scope="scope">
    <span v-if="scope.row.status === '1' || scope.row.status === 1">正常</span>
    <span v-else-if="scope.row.status === '0' || scope.row.status === 0">停用</span>
    <span v-else>{{ scope.row.status }}</span>
  </template>
</el-table-column>
<el-table-column prop="bound_students" label="已绑定学员"></el-table-column>
<el-table-column prop="quantity" label="数量"></el-table-column>
<el-table-column prop="create_time" label="录入时间"></el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_vehicle_file_id="ma_vehicle_file_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
                :close-on-click-modal="false"
                :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

  </div>
</template>

<script>
import Ma_vehicle_fileApi from '@/api/ma_vehicle_file.js';
import AfuncApi from '@/api/afunc.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search:"",
        year: "2026",
        organization: "",
        license_number: "",
        vehicle_type: "",
        status: "",
        start_date: "",
        end_date: ""
      },

      open_add:false,
      open_edit:false,
      ma_vehicle_file_id:"",
      dialogVisible:false,
      open_import:false,
      /*选中的*/
      selection: [],
      selectedRows: [], // 选中的行数据
      /*组织列表*/
      organizationList: [],
      /*车辆类型列表*/
      vehicleTypeList: [],
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
    /*获取组织列表*/
    this.getOrganizationList();
    /*获取车辆类型列表*/
    this.getVehicleTypeList();
  },
  methods: {
    dialogFormVisible(){
      this.dialogVisible = false;
    },
    setting(e){//车辆档案标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    /*获取组织列表*/
    getOrganizationList() {
      let self = this;
      AfuncApi.call({
        model: 'ma_company',
        action: 'getList',
        page: 1,
        list_rows: 1000
      })
        .then(data => {
          if (data.data && data.data.list && data.data.list.data) {
            self.organizationList = data.data.list.data;
          }
        })
        .catch(error => {
        });
    },
    /*获取车辆类型列表*/
    getVehicleTypeList() {
      let self = this;
      AfuncApi.call({
        model: 'vehicle_classification',
        action: 'getList',
        page: 1,
        list_rows: 1000
      })
        .then(data => {
          if (data.data && data.data.list && data.data.list.data) {
            self.vehicleTypeList = data.data.list.data;
          }
        })
        .catch(error => {
        });
    },
    /*重置表单*/
    resetForm() {
      this.formInline = {
        search:"",
        year: "2026",
        organization: "",
        license_number: "",
        vehicle_type: "",
        status: "",
        start_date: "",
        end_date: ""
      };
    },
    /*清空选择*/
    clearSelection() {
      if (this.multipleTable) {
        this.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    importClick() {
      this.open_import = true;
    },
    exportData() {
      // 构建导出参数
      let exportParams = {
        name: this.formInline.name,
      };

      // 如果有选中的数据，添加选中的ID；否则导出全部（不传selected_ids参数）
      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.ma_vehicle_file_id);
        exportParams.selected_ids = selectedIds.join(',');
      }

      // 使用页面跳转方式导出，避免blob处理
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
          .filter(key => exportParams[key] !== '')
          .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
          .join('&');

      window.location.href = baseUrl + '/index.php/shop/plus.ma_vehicle_file.Index/export?' + queryString;
    },
    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Ma_vehicle_fileApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true
    },

    /*编辑活动*/
    editClick(row) {
      this.ma_vehicle_file_id = row.ma_vehicle_file_id;
      this.open_edit = true
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_vehicle_fileApi.del(
                {
                  ma_vehicle_file_id: row.ma_vehicle_file_id
                },
                true
            )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ma_vehicle_file/index/index.vue